import lightAsset from "@/assets/strifit-login-light.png.asset.json";
import darkAsset from "@/assets/strifit-login-dark.png.asset.json";
import { resolveAppBranding } from "@/config/appBranding";

export interface LoginBackgrounds {
  loginLight?: string | null;
  loginDark?: string | null;
}

// Absolute asset URLs also work in native apps and on dedicated tenant domains.
const appAssetUrl = (url: string) => new URL(url, "https://fit-reserve-master.lovable.app").href;

export function resolveLoginBackground(appName: string, mode: "light" | "dark", backgrounds?: LoginBackgrounds): string | null {
  if (resolveAppBranding(appName).key === "StriFit") {
    return appAssetUrl(mode === "light" ? lightAsset.url : darkAsset.url);
  }
  return backgrounds?.[mode === "light" ? "loginLight" : "loginDark"] ?? null;
}